
import * as platform from 'platform';
import { environment } from '../../environments/environment';

export class VariablesGlobales {
    static _equipo:string = platform?.os?.family + ' ' + platform?.os?.version + ' ' + platform?.os?.architecture+'bits';
    static _idEquipo:string = "";
    static _idKernel:string = platform.description? platform.description : 'NO KERNEL';

    public static _getBody(m:string,i:number):any{
        let zone = new Date().getTimezoneOffset() / -60;
        var _body = {
            "aplicacion":environment.id,
            "id_qrt":i,
            "data":{
                "zona": zone,
                "metodo": m,
                "token": "",
                "equipo": this._equipo,
                "idequipo": this._idEquipo || '192.168.1.1', //'192.168.1.1', 
                "idkernel": this._idKernel
            }
        };
        return _body;
    }
}